import { model } from '@modern-js/runtime/model';
import { Message } from '@arco-design/web-react';
import { getUserInfo, getXSRFToken } from '@/api/editorial';
import { getPurpose } from '@/api/package';
import { PurposeInfo } from '@/constants/purpose';

interface State {
  loading: boolean;
  token: string;
  user: any;
  loaded: boolean;
  purposeList: PurposeInfo[];
}

export default model<State>('user').define({
  state: {
    loading: false,
    /** 接口是否调用完成，成功失败都会变为 true */
    loaded: false,
    token: null,
    user: null,
    purposeList: [],
  },
  actions: {
    getUserInfo: {
      pending(state) {
        state.loading = true;
      },
      fulfilled(state, payload) {
        state.loading = false;
        state.loaded = true;
        state.token = payload.token;
        state.user = payload.user;
      },
      rejected(state) {
        state.loading = false;
        state.loaded = true;
      },
    },
    getPurposeList: {
      fulfilled(state, body) {
        const { purposes = [] } = body;
        Object.assign(state, {
          purposeList: purposes,
        });
      },
    },
  },
  effects: {
    /**
     * @param callbackUrl 传 false 不自动跳转
     * @returns
     */
    async getUserInfo(callbackUrl = `${location.pathname}${location.search}`) {
      try {
        const result = await getXSRFToken();
        const token = result.xsrftoken;
        localStorage.setItem('xsrftoken', token);
        const userResponse = await getUserInfo(token);
        if (userResponse?.userInfo) {
          return { user: userResponse.userInfo, token };
        }
        // 用户没有套餐的时候，会返回errno 70013，直接到用户中心
        if (userResponse.errno === 70013) {
          window.location.href = '/user';
          return null;
        } else if (callbackUrl) {
          window.location.href = `/account/login?callbackUrl=${callbackUrl}`;
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return await Promise.reject();
      } catch {
        if (callbackUrl) {
          window.location.href = `/account/login?callbackUrl=${callbackUrl}`;
        }
      }
      return null;
    },
    async getPurposeList(goodsType = 0) {
      try {
        const result = await getPurpose({
          goodsType,
        });
        return result;
      } catch (error: any) {
        Message.error(error?.message || error?.errmsg || '');
        return {};
      }
    },
  },
});
